import { ApolloClient } from '@apollo/client';
import { Dispatch } from 'redux';

import {
  ImpactAiNonprofitSearchDocument,
  ImpactAiNonprofitSearchQuery,
  ImpactAiNonprofitSearchQueryVariables,
} from 'generated/graphql';

import { CallActionPayload, MethodResponse, UIStateCallback } from '../../types';
import { ContextAPI } from '../ImpactAiContextProvider';
import { SearchNonprofitsPayload } from '../../../../containers/BackOfficeImpactAiPresets/types';

export const searchNonprofits = async (
  payload: CallActionPayload,
  client: ApolloClient<unknown>,
  contextApi: ContextAPI,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  uiStateCallback?: UIStateCallback
): Promise<MethodResponse> => {
  const {
    outputPath,
    searchTerm,
    acceptsDonations,
    causes,
    countryCode,
    stateCode,
    donationProvider,
    excludeDonationProviders,
    includeApproved,
    limit = 10,
    offset = 0,
    waitForCompletion = true,
  } = payload as unknown as SearchNonprofitsPayload;

  if (!outputPath) {
    throw new Error('outputPath is required for search-nonprofits method');
  }

  if (uiStateCallback) {
    uiStateCallback('processing');
  }

  // DIRTY HACKZ
  const cleanedCauses = causes?.[0];

  const performSearch = async (): Promise<void> => {
    try {
      const { data } = await client.query<
        ImpactAiNonprofitSearchQuery,
        ImpactAiNonprofitSearchQueryVariables
      >({
        query: ImpactAiNonprofitSearchDocument,
        variables: {
          searchTerm,
          acceptsDonations,
          causes: cleanedCauses,
          countryCode,
          stateCode,
          donationProvider,
          excludeDonationProviders,
          includeApproved,
          limit,
          offset,
        },
        fetchPolicy: 'network-only',
      });

      const nonprofits = data?.searchNonprofits || [];

      // Set results in context
      contextApi.setValue(outputPath, nonprofits);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error searching nonprofits:', error);
      throw error;
    }
  };

  if (!waitForCompletion) {
    performSearch()
      .then(() => {
        if (uiStateCallback) {
          uiStateCallback('complete');
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Background searchNonprofits failed:', error);
        if (uiStateCallback) {
          uiStateCallback('error');
        }
      });

    if (uiStateCallback) {
      uiStateCallback('complete');
    }

    return {};
  }

  try {
    await performSearch();

    if (uiStateCallback) {
      uiStateCallback('complete');
    }

    return {};
  } catch (error) {
    if (uiStateCallback) {
      uiStateCallback('error');
    }
    return { error: true };
  }
};
